<template>
  <div class="verify-box">
    <van-cell class="verify-code verify-code-wap ver-com" required>
      <template slot="title">
        <span class="custom-text">{{lang.verifyCode}}</span>
      </template>
      <div class="verify-content">
        <input type="text" v-model="verifyCode" :placeholder="lang.enter" maxlength="4" @input="setVerifyCode">
        <img :src="verifyImg" alt="" class="verify-img" @click="loadImg">
      </div>
    </van-cell>

    <div class="verify-code-pc">
      <!-- 验证码 -->
      <span class="reg-title nowarp"> {{lang.verifyCode}}<label class="reg-required">*</label> :</span> <input @input="setVerifyCode" maxlength="4" type="text" :placeholder="lang.enter" v-model="verifyCode">
      <img :src="verifyImg" alt="" class="verify-img" @click="loadImg">
    </div>

  </div>
</template>

<script>
    // import {
    //     Cell,
    //     CellGroup
    // } from "vant";
    import lang from "./../../common/language/register";
    export default {
        data() {
            return {
                lang: lang,
                verifyImg: "",
                verifyCode: "",
                verifyToken: "",
                cacheNum:"",
            }
        },
        created() {
            this.loadImg();
        },
        methods: {
            loadImg() {
                // console.log("加载")
                this.axios.get(this.pub.getApi().GetRecaptcha).then(res => {
                    if (res.data.code === 0) {
                        this.verifyCode = ""; //重置验证码
                        this.verifyImg = "data:image/png;base64," + res.data.result.image;
                        this.verifyToken = res.data.result.token;
                    }
                })
            },
            setVerifyCode(field){
            const num=this.verifyCode;
            (/^$|^\d+$/).test(num)?this.cacheNum=num:this.verifyCode= this.cacheNum;
            this.$emit('setVerifyCode', this.verifyCode,this.verifyToken)
            },

        },
        // components: {
        //     [Cell.name]: Cell,
        //     [CellGroup.name]: CellGroup
        // }
    };
</script>

<style lang="scss">
    .verify-code {
        position: relative;
        padding: 2px 15px !important;
        line-height: 44px !important;

        .van-cell__title {
            display: flex;
            align-items: center;
        }
        // &::before{
        // top: 10px;
        // }
        
    }
    .verify-code-wap .verify-img{
        width:42%;
    }

    .verify-img {
        width: 50%;
        height: 30px;
        //   border:solid 1px #D9D9D9;
         max-width: 120px;
         cursor: pointer;
    }

    .verify-content {
        display: flex;
        justify-content: flex-end;
        height: 100%;
        align-items: center;

        input {
            border: none;
            text-align: left;
            background-color: #FBFBFD;
            width: 58%;
            // border: solid 1px red;
            margin-right: 10px;
            height:30px;

           

        }
    }
    .verify-code-pc{
        text-align: left;
        // width: 700px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        img{
            margin-left: 10px;
            border:solid 1px lightgray;
        }
    }
    .nowarp{
        white-space:nowrap;
    }
    .verify-box .ver-com .van-cell__title{
        max-width: 82px !important;
    }


</style>